"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkToRecordType;

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _FormControlLabel2 = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Tooltip2 = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CloseRounded2 = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _ArrowBackIosRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowBackIosRounded"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _react = _interopRequireWildcard(require("react"));

var _Switch = _interopRequireDefault(require("../../components/Switch"));

var _propTypes = require("../../propTypes");

var _excluded = ["setOptions", "options", "getData"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

LinkToRecordType.propTypes = _propTypes.OptionProps;

function LinkToRecordType(_ref) {
  var _selectedTable$views;

  var setOptions = _ref.setOptions,
      options = _ref.options,
      getData = _ref.getData,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTable = _useState2[0],
      setSelectedTable = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      projects = _useState4[0],
      setProjects = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      tables = _useState6[0],
      setTables = _useState6[1];

  var _useState7 = (0, _react.useState)(options.foreignTableId ? 3 : 1),
      _useState8 = _slicedToArray(_useState7, 2),
      step = _useState8[0],
      setStep = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isLoading = _useState10[0],
      setIsLoading = _useState10[1];

  var getProject = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsLoading(true);
              _context.next = 4;
              return getData("project");

            case 4:
              res = _context.sent;
              _context.next = 7;
              return getTable(res);

            case 7:
              setProjects(res);
              setIsLoading(false);
              return _context.abrupt("return", res);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              setIsLoading(false);
              return _context.abrupt("return", _context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function getProject() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getTable = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
      var res, selected;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setIsLoading(true);
              _context2.next = 4;
              return getData("table", value);

            case 4:
              res = _context2.sent;
              setTables(res);

              if (options.foreignTableId && !selectedTable) {
                selected = res.find(function (item) {
                  return item.id === options.foreignTableId;
                });
                setSelectedTable(selected);
              }

              setIsLoading(false);
              return _context2.abrupt("return", res);

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              setIsLoading(false);
              return _context2.abrupt("return", _context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function getTable(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getProject();

    if (!options.relationship) {
      setOptions(_objectSpread(_objectSpread({}, options), {}, {
        relationship: "one"
      }));
    }
  }, []);

  var handleChangeProject = function handleChangeProject(e, value) {
    setStep(2);
    getTable(value);
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      foreignProjectId: value.id
    }));
  };

  var handleChangeTable = function handleChangeTable(e, value) {
    setStep(3);
    getTable(value);
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      foreignTableId: value.id
    }));
    setSelectedTable(value);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 12,
      minHeight: 100
    }
  }, step === 1 && /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    open: true,
    fullWidth: true,
    size: "small",
    options: projects,
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    onChange: handleChangeProject,
    popupIcon: "",
    loading: isLoading,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        autoFocus: true,
        placeholder: "Select Workspace",
        fullWidth: true,
        variant: "outlined",
        size: "small"
      }));
    }
  }), step === 2 && /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    open: true,
    fullWidth: true,
    size: "small",
    options: tables,
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    onChange: handleChangeTable,
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    popupIcon: "",
    loading: isLoading,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        autoFocus: true,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment2["default"], {
            position: "start"
          }, /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
            onClick: function onClick() {
              return setStep(1);
            },
            size: "small",
            startIcon: /*#__PURE__*/_react["default"].createElement(_ArrowBackIosRounded2["default"], {
              style: {
                fontSize: 12
              }
            })
          }, "Back"))
        }),
        placeholder: "Select a board",
        fullWidth: true,
        variant: "outlined",
        size: "small"
      }));
    }
  }), step === 3 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "subtitle1",
    color: "textSecondary"
  }, "This field will link to records in the", " ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 500,
      color: "rgba(75, 85, 99, 1)"
    }
  }, selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.name), " table", /*#__PURE__*/_react["default"].createElement(_Tooltip2["default"], {
    title: "Reset",
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
    onClick: function onClick() {
      var newOptions = _objectSpread({}, options);

      delete newOptions.foreignProjectId;
      delete newOptions.foreignTableId;
      setOptions(newOptions);
      setStep(1);
    },
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_CloseRounded2["default"], {
    style: {
      fontSize: 16
    }
  })))), /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Allow linking to multiple records"),
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: options.relationship === "many",
      onChange: function onChange(e) {
        return setOptions(_objectSpread(_objectSpread({}, options), {}, {
          relationship: e.target.checked ? "many" : "one"
        }));
      }
    }),
    style: {
      marginLeft: 0,
      marginTop: 8
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Limit record selection to a view"),
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: options.viewId && options.viewId !== "",
      onChange: function onChange(e) {
        setOptions(_objectSpread(_objectSpread({}, options), {}, {
          viewId: e.target.checked ? selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.viewActiveId : ""
        }));
      }
    }),
    style: {
      marginLeft: 0,
      marginTop: 8
    }
  }), options.viewId && /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    style: {
      marginTop: 12
    },
    fullWidth: true,
    size: "small",
    options: (selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.views) || [],
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    value: options.viewId ? selectedTable === null || selectedTable === void 0 ? void 0 : (_selectedTable$views = selectedTable.views) === null || _selectedTable$views === void 0 ? void 0 : _selectedTable$views.find(function (item) {
      return item.id === options.viewId;
    }) : null,
    onChange: function onChange(e, value) {
      return setOptions(_objectSpread(_objectSpread({}, options), {}, {
        viewId: value === null || value === void 0 ? void 0 : value.id
      }));
    },
    disableClearable: true,
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        placeholder: "Select a view",
        fullWidth: true,
        variant: "outlined",
        size: "small"
      }));
    }
  })));
}